/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */

import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import './LoanDataDisplay.scss';
import fmt from 'indian-number-format';

// Define TypeScript interfaces
interface InterestPayableItem {
  pledgeNumber: string;
  dateOfLoan: string;
  branch: string;
  obName: string;
  principal: number;
  scheme: string;
  interestAsPerScheme: number;
  currentInterestRate: number;
  interestDays: number;
  accuredInterest: number;
}

interface InterestPayableProps {
  data: InterestPayableItem[];
}

const columns: ColumnsType<InterestPayableItem> = [
  {
    title: 'S.No',
    dataIndex: 'serialNumber',
    key: 'serialNumber',
  },
  {
    title: 'Pledge Number',
    dataIndex: 'pledgeNumber',
    key: 'pledgeNumber',
  },
  {
    title: 'Date of Loan',
    dataIndex: 'dateOfLoan',
    key: 'dateOfLoan',
  },
  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
  },
  {
    title: 'Borrower Name',
    dataIndex: 'obName',
    key: 'obName',
  },
  {
    title: 'Principal',
    dataIndex: 'principal',
    key: 'principal',
    render: (amt: number) => fmt.format(amt),
  },
  {
    title: 'Outstanding Principal',
    dataIndex: 'outstandingPrincipal',
    key: 'outstandingPrincipal',
    render: (amt: number) => fmt.format(amt),
  },
  {
    title: 'Scheme',
    dataIndex: 'scheme',
    key: 'scheme',
  },
  {
    title: 'Interest as per Scheme',
    dataIndex: 'interestAsPerScheme',
    key: 'interestAsPerScheme',
    render: (rate: number) => `${rate}%`,
  },
  {
    title: 'Current Interest Rate',
    dataIndex: 'currentInterestRate',
    key: 'currentInterestRate',
    render: (rate: number) => `${rate}%`,
  },
  {
    title: 'Interest Days',
    dataIndex: 'interestDays',
    key: 'interestDays',
  },
  {
    title: 'Accrued Interest',
    dataIndex: 'accuredInterest',
    key: 'accuredInterest',
    render: (amt: number) => fmt.format(amt),
  },
  {
    title: 'Penal Interest',
    dataIndex: 'penalInterest',
    key: 'penalInterest',
    render: (amt: number) => fmt.format(amt),
  },
];

const InterestPayableDisplay: React.FC<InterestPayableProps> = ({ data }) => {
  return (
    <div className="loan-data-container">
      <h2>Interest Payable Report</h2>
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(_, idx) => (idx !== undefined ? idx.toString() : '')}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

export default InterestPayableDisplay;
